import { useContext, useEffect, useRef, useState } from "react";
import { tenantContext } from "../Main/contexts";

import { CreateTemplate, DeleteTemplate, GetTemplate, iDataColumn, iTemplate, UpdateTemplate } from "./TenantAPI";
import { dataColumn } from "../Generic/DataTable";
import { sortByField, SortEnquiriesParams } from "../Logic/sort";
import Loading from "../Generic/loading";
import TextBox from "../Generic/TextBox";
import { lengthIsLessThan } from "../Logic/validationRules";

import TopBar from "./Shared/topBar";
import LeftBar from "./Shared/leftBar";
import { GetConfig, GetConfigResponse, iMailboxConfig } from "../Logic/config";
import HtmlEditor from "../Generic/HTMLEditor";
import CheckBoxList from "../Generic/CheckboxList";
function Templates() {
    const { selectedTenant, mailboxes, actions, mailboxEditorConfigurations } = useContext(tenantContext);
    const [isLoading, setIsLoading] = useState<Boolean>(true);
    const [config, setConfig] = useState<GetConfigResponse | undefined>(undefined);
    const [filtertedGridaData, setFiltertedGridaData] = useState<Array<iDataColumn>>([]);
    const [sortBy, setSortBy] = useState<SortEnquiriesParams>();
    const [selectedItem, setSelectedItem] = useState<iDataColumn>({ name: "", id: 0 });
    const [validationErrors, setValidationErrors] = useState<Array<string>>([]);
    const [isNew, setIsNew] = useState<Boolean | undefined>(undefined);
    const [selectedTemplate, setSelectedTemplate] = useState<iTemplate | undefined>(undefined);
    const [defaultEditorConfig, setDefaultEditorConfig] = useState<iMailboxConfig | undefined>(undefined);
    const [selectedItem1, setSelectedItem1] = useState("");
    useEffect(() => {
        (async () => {
            await getConfig();
        })();
    }, [selectedTenant]);

    useEffect(() => {
        (async () => {
            await getTemplateInfomation(selectedItem1);
        })();
    }, [selectedItem1]);

    async function getConfig() {
        if (selectedTenant) {
            const config_results = GetConfig(selectedTenant.token);

            Promise.all([config_results]).then(results => {
                if (results[0].isOk && results[0].data) {
                    setConfig(results[0].data);

                    setFiltertedGridaData(
                        results[0].data.templates
                            .sort((n1, n2) => {
                                if (n1.name > n2.name) {
                                    return 1;
                                }

                                if (n1.name < n2.name) {
                                    return -1;
                                }

                                return 0;
                            })
                            .map(x => {
                                return { id: x.id, name: x.name };
                            }),
                    );
                }

                setIsLoading(false);
            });
        }
    }

    let AllColumns: dataColumn<iDataColumn>[] = [
        {
            title: <>Templates</>,
            toolTip: "name",
            key: "name",
            getData: (data: iDataColumn) => {
                return <>{data.name}</>;
            },
            width: "100%",
            canResize: false,
            sort: {
                direction: undefined,
                sortMethod: () => {
                    handleHeaderClick("name");
                },
                displayIcon: false,
            },
            textAlignment: "left",
            minWidth: "60px",
        },
    ];

    const handleHeaderClick = (fieldName: string): any => {
        let sortO = sortBy;
        if (!sortO) {
            sortO = {
                orderBy: fieldName,
                desc: false,
            };
        } else {
            sortO.orderBy = fieldName;
            sortO.desc = sortO.desc ? false : true;
        }
        let updatedGrids = sortByField(filtertedGridaData, fieldName, sortO.desc);
        setFiltertedGridaData(updatedGrids);
        setSortBy(sortO);
    };
    const getTemplateInfomation = async (val: string) => {
        if (val && val !== "") {
            const template = await GetTemplate(selectedTenant!.token, parseInt(val));
            if (template.isOk && template.data) {
                template.data.include = "";
                setSelectedTemplate(template.data);
                setSelectedItem(template.data);
                setDefaultEditorConfig(
                    mailboxEditorConfigurations.find(x => x.id == template.data!.mailboxes[0])?.config,
                );
            }
            setIsNew(false);
        }
    };
    const getTemplateInfo = (val: string) => {
        setIsNew(undefined);
        setSelectedItem1(val);
    };

    const addTemplate = async () => {
        let defTemplate: iTemplate = {
            id: 0,
            name: "",
            sourceID: 0,
            subject: "",
            body: "",
            include: "",
            actions: [],
            mailboxes: [],
            updatedAt: new Date(),
        };

        setSelectedItem(defTemplate);
        setSelectedTemplate(defTemplate);
        setIsNew(true);
    };
    const updateTemplate = async () => {
        if (selectedTenant && selectedTemplate) {
            const resp = await UpdateTemplate(selectedTenant.token, selectedTemplate);
            if (resp.isOk) {
                alert("template updated");
                await getConfig();
                setIsNew(undefined);
            } else {
                alert("An error occured");
            }
        }
    };

    const deleteTemplate = async () => {
        if (selectedTenant) {
            if (selectedItem.id > 0) {
                if (
                    selectedTemplate?.mailboxes &&
                    selectedTemplate.mailboxes.length > 0 &&
                    selectedTemplate?.actions &&
                    selectedTemplate.actions.length > 0
                ) {
                    alert("Please remove the template from all Mailboxes and Actions before deleting");
                    return;
                }

                let confirmDelete = window.confirm("Are you sure you want to delete this Template?");
                if (confirmDelete) {
                    DeleteTemplate(selectedTenant.token, selectedItem.id).then(resp => {
                        if (resp.isOk) {
                            alert("Template deleted");
                            getConfig();
                            setIsNew(undefined);
                        } else {
                            alert("An error occured");
                        }
                    });
                }
            } else {
                alert("An Error occured name is invalid or no Template selected to delete");
            }
        }
    };

    const createTemplate = async () => {
        if (
            selectedTemplate &&
            selectedTenant &&
            selectedTemplate.name.length > 0 &&
            selectedTemplate.name.length < 81
        ) {
            const resp = await CreateTemplate(selectedTenant.token, selectedTemplate);
            if (resp.isOk) {
                alert("template created");
                await getConfig();
                setIsNew(undefined);
            } else {
                alert("An error occured");
            }
        } else {
            alert("An Error occured. Name is invalid , length has to be between 1 and 80 characters");
        }
    };

    function OnFilter(filterValue: string) {
        if (config) {
            let filtertedList = config.templates.map(x => {
                return { id: x.id, name: x.name };
            });
            let filtered = filtertedList.filter(x => x.name.toLowerCase().includes(filterValue.toLowerCase()));
            setFiltertedGridaData(filtered);
        }
    }

    const updateValue = (field: string, value: any) => {
        let tTemplate = selectedTemplate ? JSON.parse(JSON.stringify(selectedTemplate)) : {};
        tTemplate[field] = value;
        setSelectedTemplate(tTemplate);
    };

    const updateBody = (val: string) => {
        updateValue("body", val);
    };

    const updateInclude = (val: string) => {
        updateValue("include", val);
    };

    const updateMailboxNumber = (val: string[]) => {
        const numberArray: number[] = val.map(str => +str);
        updateValue("mailboxes", numberArray);
    };
    const updateActionNumber = (val: string[]) => {
        const numberArray: number[] = val.map(str => +str);
        updateValue("actions", numberArray);
    };

    const copyTemplate = async (val: string) => {
        setIsNew(undefined);
        const template = await GetTemplate(selectedTenant!.token, parseInt(val));
        if (template.isOk && template.data) {
            let copiedTemplate = template.data;
            copiedTemplate.name += " - Copy";
            copiedTemplate.mailboxes = [];
            copiedTemplate.include = "";
            copiedTemplate.id = 0;
            setSelectedTemplate(copiedTemplate);
            setSelectedItem(copiedTemplate);
            setIsNew(true);
        }
    };

    return (
        <>
            <TopBar
                label={"Templates"}
                isNew={isNew}
                updateFunction={updateTemplate}
                addFunction={addTemplate}
                createFunction={createTemplate}
                deleteFunction={deleteTemplate}
            ></TopBar>
            <div style={{ display: "flex", flexDirection: "row", height: "calc(100% - 51px)" }}>
                <div className="bodyCol1">
                    {" "}
                    {isLoading && <Loading></Loading>}
                    {!isLoading && (
                        <LeftBar
                            AllColumns={AllColumns}
                            gridData={filtertedGridaData}
                            onRowClick={getTemplateInfo}
                            selectedItem={selectedItem}
                            onFilter={OnFilter}
                            onContextMenuClick={copyTemplate}
                        ></LeftBar>
                    )}
                </div>
                {isNew != undefined && (
                    <div className="bodyCol2">
                        <div className="optionsRow">
                            <p style={{ marginBottom: "6px", marginTop: "-0px", fontWeight: "bold", fontSize: "12pt" }}>
                                {!isNew ? "Edit" : "Create"} Template{" "}
                            </p>
                        </div>
                        <div className="formRow">
                            <TextBox
                                id={"name"}
                                label="Name"
                                value={selectedTemplate?.name}
                                onChange={(field: string, value: any) => {
                                    updateValue(field, value);
                                }}
                                maxLength={80}
                                requiredIdentifier={true}
                                errorMessage={
                                    validationErrors.find(x => x == "name")
                                        ? "Field must be less than 80 characters"
                                        : ""
                                }
                                validationFunc={lengthIsLessThan}
                            ></TextBox>
                        </div>
                        <div className="formRow">
                            <TextBox
                                id={"subject"}
                                label="Subject"
                                value={selectedTemplate?.subject}
                                onChange={(field: string, value: any) => {
                                    updateValue(field, value);
                                }}
                                maxLength={80}
                                requiredIdentifier={true}
                                errorMessage={
                                    validationErrors.find(x => x == "subject")
                                        ? "Field must be less than 80 characters"
                                        : ""
                                }
                                validationFunc={lengthIsLessThan}
                            ></TextBox>
                        </div>
                        <div className="formRow">
                            <CheckBoxList
                                id={"Actions_Id"}
                                label="Actions"
                                options={actions.map(x => {
                                    return { label: x.name, value: x.id.toString() };
                                })}
                                value={selectedTemplate ? selectedTemplate.actions.map(num => num.toString()) : []}
                                errorMessage=""
                                onChange={updateActionNumber}
                            ></CheckBoxList>
                        </div>
                        <div className="formRow">
                            <CheckBoxList
                                id={"mailbox_Id"}
                                label="Mailboxes"
                                options={mailboxes.map(x => {
                                    return { label: x.name, value: x.id.toString() };
                                })}
                                value={selectedTemplate ? selectedTemplate.mailboxes.map(num => num.toString()) : []}
                                errorMessage=""
                                onChange={updateMailboxNumber}
                            ></CheckBoxList>
                        </div>
                        <div className="formRow">
                            Body
                            <br />
                            <HtmlEditor
                                key={"_bodyEditor"}
                                initialValue={selectedTemplate ? selectedTemplate.body : ""}
                                onChange={updateBody}
                                height="1250px"
                                derfaultValues={defaultEditorConfig}
                            ></HtmlEditor>
                        </div>
                        {/**  <div className="formRow">
                            Include
                            <br />
                            <HtmlEditor
                                key={"_includeEditor"}
                                initialValue={selectedTemplate ? selectedTemplate.include : ""}
                                onChange={updateInclude}
                                height="1250px"
                            ></HtmlEditor>
                        </div>*/}
                    </div>
                )}
            </div>
        </>
    );
}
export default Templates;
